import { render, staticRenderFns } from "./order-items-woitems-sub-list.vue?vue&type=template&id=68a3d9c2&scoped=true&"
import script from "./order-items-woitems-sub-list.vue?vue&type=script&lang=js&"
export * from "./order-items-woitems-sub-list.vue?vue&type=script&lang=js&"
import style0 from "./order-items-woitems-sub-list.vue?vue&type=style&index=0&id=68a3d9c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a3d9c2",
  null
  
)

export default component.exports